import React from 'react';

export type PipelineStage =
  | 'new_business'
  | 'esign_sent'
  | 'esign_completed'
  | 'verification'
  | 'processor_submission'
  | 'underwriting_review'
  | 'conditional_approval'
  | 'pended'
  | 'client_returned'
  | 'ready_to_build'
  | 'activation'
  | 'live'
  | 'declined_by_agms'
  | 'declined_by_fiserv';

const stageLabels: Record<PipelineStage, string> = {
  new_business: 'New Business',
  esign_sent: 'eSign Sent',
  esign_completed: 'eSign Completed',
  verification: 'Verification',
  processor_submission: 'Processor Submission',
  underwriting_review: 'Underwriting Review',
  conditional_approval: 'Conditional Approval',
  pended: 'Pended',
  client_returned: 'Client Returned',
  ready_to_build: 'Ready to Build',
  activation: 'Activation',
  live: 'Live',
  declined_by_agms: 'Declined by AGMS',
  declined_by_fiserv: 'Declined by Fiserv',
};

const stageLabelsRecord: Record<string, string> = stageLabels

export function isPipelineStage(stage: string): stage is PipelineStage {
  return Object.prototype.hasOwnProperty.call(stageLabelsRecord, stage)
}

const stageStyles: Record<PipelineStage, string> = {
  new_business: 'stage-new-business',
  esign_sent: 'stage-esign-sent',
  esign_completed: 'stage-esign-completed',
  verification: 'stage-verification',
  processor_submission: 'stage-processor-submission',
  underwriting_review: 'stage-underwriting-review',
  conditional_approval: 'stage-conditional-approval',
  pended: 'stage-pended',
  client_returned: 'stage-client-returned',
  ready_to_build: 'stage-ready-to-build',
  activation: 'stage-activation',
  live: 'stage-live',
  declined_by_agms: 'stage-declined',
  declined_by_fiserv: 'stage-declined',
};

export interface PipelineBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  stage: PipelineStage;
  size?: 'sm' | 'md' | 'lg';
}

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export function PipelineBadge({
  stage,
  size = 'md',
  className = '',
  ...props
}: PipelineBadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full border ring-1 ring-inset ring-black/5
        ${stageStyles[stage]}
        ${sizeStyles[size]}
        ${className}
      `.trim()}
      {...props}
    >
      {stageLabels[stage]}
    </span>
  );
}
